// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"014350da","434":"fc18cae3"}[chunkId] + ".chunk.css";
};